export default __webpack_public_path__ + "assets/RZy1Z.jpg";